import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Contract_Event } from '../models/contract_event.model';
import { GLOBAL } from './global';
import { VariableService } from '../services/sharedVariables';

@Injectable()
export class EventService{
   public url: string;
   public user_id:number;

   constructor(
     public _http: Http,
     public VariableService: VariableService
   )
   {
     this.url = GLOBAL.url;
     this.user_id = parseInt(this.VariableService.getCookie('user_id'));
   }

   getContract_events(contract_id:number)
   {
     return this._http.get(this.url+'contract_event/'+contract_id+'/'+this.user_id).map(res => res.json());
   }

   getContract_event()
   {
     return "getContract_event from service";
   }

   addContract_event(contract_event: Contract_Event)
   {
     let json = JSON.stringify(contract_event);
     let params = 'json='+json;
     console.log(params);
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     return this._http.post(this.url+'add-contract_event/'+this.user_id,params, {headers:headers}).map(res => res.json());

   }

   updateContract_event(id:number,pContract_event: Contract_Event)
   {
     let json = JSON.stringify(pContract_event);
     let params = "json="+json;
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     console.log(params);
     return this._http.post(this.url+'edit-contract_event/'+id+'/'+this.user_id,params,{headers: headers})
                       .map(res => res.json());
   }

   deleteContract_event(id:number)
   {
     return this._http.get(this.url+'delete-contract_event/'+id+'/'+this.user_id)
                     .map(res => res.json());
   }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/contract_event.service.ts